import {
  LOAD_PROGRAMMES_DATA,
  LOAD_PROGRAMMES_DATA_SUCCESS,
  SELECTED_PROGRAMME_UPDATE,
  LOAD_TERMS_DATA,
  LOAD_TERMS_DATA_SUCCESS,
  LOAD_COURSES_DATA,
  LOAD_COURSES_DATA_SUCCESS,
  LOAD_ROLES_DATA,
  LOAD_ROLES_DATA_SUCCESS,
  LOAD_USER_DATA,
  LOAD_USER_DATA_SUCCESS,
  CLEAR_COURSES_DATA,
  SELECTED_TERM_UPDATE,
  UPDATE_FILTERED_COURSE_DATA,
  SIS_POST_ENROLLMENTS,
  SIS_POST_ENROLLMENTS_SUCCESS,
  UPDATE_STEUP_PROGRESS,
  UPDATE_USERE_EMAIL_LIST,
  SIS_STATUS,
  SIS_STATUS_SUCCESS,
  CLEAR_SUMMERY_COURSES,
  ACCESS_TOKEN,
  UPDATE_CSV_ACTION,
  LOAD_PROGRAMMES_DATA_BY_ID,
  LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS,
  SELECTED_SUB_ACCOUNT_UPDATE,
  LOAD_COURSES_DATA_START,
  UPLOAD_REQUEST,
  UPLOAD_PROGRESS,
  UPLOAD_SUCCESS,
  UPLOAD_FAILURE,
  CSV_FIlE_SELECT,
  LOAD_SECTION_DATA,
  LOAD_SECTION_DATA_SUCCESS,
  UPDATE_SECTION_USER_DATA,
  UPDATE_ZOOM_COURSE_DATA,
  UPDATE_ZOOM_COURSE_TYPE,
  ZOOM_COURSE_UPLOAD_REQUEST,
  ZOOM_COURSE_UPLOAD_SUCCESS,
  ZOOM_COURSE_UPLOAD_FAILURE,
  CREATE_GROUP_CATEGORY,
  SUCCESS_GROUP_CATEGORY,
  LOAD_COURSE_USER_DATA_START,
  LOAD_COURSE_USER_DATA,
  LOAD_COURSE_USER_DATA_SUCCESS,
  UPDATE_SELECTED_COURSE_USER_DETAILS,
  UPDATE_COURSE_STUDENT_EVENT_DATA,
  LOAD_BEST_TEACHING_AWARD_PARAMS,
  UPDATE_BEST_TEACHING_AWARD_PARAMS,
  UPDATE_ZOOM_COURSE_ID,
  LOAD_ZOOM_EVENTS_DATA,
  UPDATE_SELECTED_ZOOM_EVENTS,
  UPDATE_ZOOM_SCHEDULERS,
  UPDATE_ZOOM_COURSE_DETAILS,
  APP_LOGIN_EXPIRED,
  CREATE_USERS_UPDATE_USER_COUNT,
  CREATE_USERS_UPDATE_CSV,
  CREATE_USERS_FORM_DATA,
  SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_REQUEST
} from '../constants/action-types'

export function loadProgrammesData(payload, key) {
  return { type: LOAD_PROGRAMMES_DATA, payload, key }
}

export function loadProgrammesDataSuccess(payload, key) {
  return { type: LOAD_PROGRAMMES_DATA_SUCCESS, payload, key }
}

export function loadProgrammesDataByID(payload, key) {
  return { type: LOAD_PROGRAMMES_DATA_BY_ID, payload, key }
}

export function loadProgrammesDataByIDSuccess(payload, key) {
  return { type: LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS, payload, key }
}

export function selectedProgrammeUpdate(payload, key) {
  return { type: SELECTED_PROGRAMME_UPDATE, payload, key }
}

export function loadTermsData(payload, key) {
  return { type: LOAD_TERMS_DATA, payload, key }
}

export function loadTermsDataSuccess(payload, key) {
  return { type: LOAD_TERMS_DATA_SUCCESS, payload, key }
}

export function selectedTermUpdate(payload, key) {
  return { type: SELECTED_TERM_UPDATE, payload, key }
}

export function selectedSubAccountUpdate(payload, key) {
  return { type: SELECTED_SUB_ACCOUNT_UPDATE, payload, key }
}

export function loadCoursesData(payload, key) {
  return { type: LOAD_COURSES_DATA, payload, key }
}

export function loadCoursesDataSuccess(payload, key, loading) {
  return { type: LOAD_COURSES_DATA_SUCCESS, payload, key, loading }
}

export function loadCoursesDataStart(loading) {
  return { type: LOAD_COURSES_DATA_START, loading }
}

export function updateFilteredCoursesData(payload) {
  return { type: UPDATE_FILTERED_COURSE_DATA, payload }
}

export function clearCoursesData(payload, key) {
  return { type: CLEAR_COURSES_DATA, payload, key }
}

export function loadRolesData(payload, key) {
  return { type: LOAD_ROLES_DATA, payload, key }
}

export function loadRolesDataSuccess(payload, key) {
  return { type: LOAD_ROLES_DATA_SUCCESS, payload, key }
}

export function loadUserData(payload, key) {
  return { type: LOAD_USER_DATA, payload, key }
}

export function loadUserDataSuccess(payload, key) {
  return { type: LOAD_USER_DATA_SUCCESS, payload, key }
}

export function postEnrollmentsData(payload) {
  return { type: SIS_POST_ENROLLMENTS, payload }
}

export function postEnrollmentsSuccess(payload) {
  return { type: SIS_POST_ENROLLMENTS_SUCCESS, payload }
}

export function updateSetupProgress(payload) {
  return { type: UPDATE_STEUP_PROGRESS, payload }
}

export function updateSummeryUserEmailList(payload) {
  return { type: UPDATE_USERE_EMAIL_LIST, payload }
}

export function getSISStatus(payload) {
  return { type: SIS_STATUS, payload }
}

export function getSISStatusSuccess(payload) {
  return { type: SIS_STATUS_SUCCESS, payload }
}

export function clearSummeryCourses(payload) {
  return { type: CLEAR_SUMMERY_COURSES, payload }
}

export function getAccessToken(payload) {
  return { type: ACCESS_TOKEN, payload }
}

export function getAccessTokenSuccess(payload) {
  return { type: ACCESS_TOKEN, payload }
}

export function updateCsvAction(payload) {
  return { type: UPDATE_CSV_ACTION, payload }
}

///////////////////
///////////////////

export const csvFileSelect = (file) => ({
  type: CSV_FIlE_SELECT,
  payload: file
})

export const uploadRequest = (file) => ({
  type: UPLOAD_REQUEST,
  payload: file
})
export const uploadProgress = (file, progress) => ({
  type: UPLOAD_PROGRESS,
  payload: progress,
  meta: { file }
})
export const uploadSuccess = (file) => ({
  type: UPLOAD_SUCCESS,
  payload: file
})
export const uploadFailure = (file, err) => ({
  type: UPLOAD_FAILURE,
  payload: err,
  error: true,
  meta: { file }
})

export function loadSectionData(payload, key) {
  return { type: LOAD_SECTION_DATA, payload, key }
}

export function loadSectionDataSuccess(payload, key) {
  return { type: LOAD_SECTION_DATA_SUCCESS, payload, key }
}

export function updateSectionUserData(payload, key) {
  return { type: UPDATE_SECTION_USER_DATA, payload, key }
}

////////////////////////////////////

export function selectZoomCourseType(payload) {
  return { type: UPDATE_ZOOM_COURSE_TYPE, payload }
}

export function updateZoomCourseEventsIds(payload) {
  return { type: UPDATE_ZOOM_COURSE_DATA, payload }
}

export function updateCourseStudentsEventsIds(payload) {
  return { type: UPDATE_COURSE_STUDENT_EVENT_DATA, payload }
}

export function loadBestTeachingAwardData(payload) {
  return { type: LOAD_BEST_TEACHING_AWARD_PARAMS, payload }
}

export function updateBestTeachingAwardParams(payload) {
  return { type: UPDATE_BEST_TEACHING_AWARD_PARAMS, payload }
}

export const uploadS3ZoomProgress = (status) => ({
  type: ZOOM_COURSE_UPLOAD_REQUEST,
  payload: status
})
export const uploadS3ZoomSuccess = (result) => ({
  type: ZOOM_COURSE_UPLOAD_SUCCESS,
  payload: result
})

export const uploadS3ZoomFailure = (err) => ({
  type: ZOOM_COURSE_UPLOAD_FAILURE,
  payload: err,
  error: true
})
export function loadGroupCategories(payload) {
  return { type: LOAD_GROUP_CATEGORY, payload }
}

export function loadGroupCategoriesDataSuccess(payload) {
  return { type: LOAD_GROUP_CATEGORY_SUCCESS, payload }
}

export function loadCoursesUserDataStart(loading) {
  return { type: LOAD_COURSE_USER_DATA_START, loading }
}

export function loadCoursesUserData(payload) {
  return { type: LOAD_COURSE_USER_DATA, payload }
}

export function loadCoursesUserDataSuccess(payload, key, loading) {
  return { type: LOAD_COURSE_USER_DATA_SUCCESS, payload, key, loading }
}

export function loadCourseDetails(payload) {
  return { type: UPDATE_SELECTED_COURSE_USER_DETAILS, payload }
}

export function updateZoomCourseId(payload) {
  return { type: UPDATE_ZOOM_COURSE_ID, payload }
}

export function updateZoomHost(payload) {
  return { type: UPDATE_ZOOM_HOST, payload }
}

export function loadZoomEventsData(payload) {
  return { type: LOAD_ZOOM_EVENTS_DATA, payload }
}

export function updateSelectedZoomEvents(payload) {
  return { type: UPDATE_SELECTED_ZOOM_EVENTS, payload }
}

export function updateZoomSchedulers(payload) {
  return { type: UPDATE_ZOOM_SCHEDULERS, payload }
}

export function updateZoomCourseDetails(payload) {
  return { type: UPDATE_ZOOM_COURSE_DETAILS, payload }
}

export function updateLoginExpireStatus(payload) {
  return { type: APP_LOGIN_EXPIRED, payload }
}

export function createUsersUpdateUserCount(payload) {
  return { type: CREATE_USERS_UPDATE_USER_COUNT, payload }
}

export function createUsersUpdateCsv(payload) {
  return { type: CREATE_USERS_UPDATE_CSV, payload }
}

export function createUsersUpdateFormData(payload) {
  return { type: CREATE_USERS_FORM_DATA, payload }
}

export function saveBestTeachingAwardFromUploadRequest(payload) {
  return { type: SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_REQUEST, payload }
}
